import { render, staticRenderFns } from "./purchaseoptions.vue?vue&type=template&id=3d45662c&scoped=true&"
import script from "./purchaseoptions.vue?vue&type=script&lang=js&"
export * from "./purchaseoptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45662c",
  null
  
)

export default component.exports